<template>
  <div class="flex flex-row flex-wrap mt2">
    <div class="p2 col-12 md-col-6">
      <loginForm title="Credenciais de acesso">
      </loginForm>
    </div>
    <div class="p2 col-12 md-col-6">
      <faleConoscoForm
        :keepMessage="true"
        :plugin="$faleConosco"
      ></faleConoscoForm>
    </div>
  </div>
</template>

<script>
import loginForm from 'acefy/dialogs/loginForm'
import faleConoscoForm from 'acefy/dialogs/faleConoscoForm'

var componentDefinition = {
  components: { faleConoscoForm, loginForm }
}
export default componentDefinition
</script>
